var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("app-launcher-settings", {
    attrs: {
      "s-active": _vm.settings,
      "s-initial": _vm.settingsInDB,
      versions: _vm.availableVersions,
      "migrations-by-range": _vm.migrationsByRange,
      "is-disabled": _vm.isSavingSettings,
      "is-saving": _vm.isSavingSettings,
    },
    on: {
      "settings-change": _vm.onSettingsChange,
      save: _vm.onSaveAppLauncherSettings,
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }